<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.phone" style="width: 140px;" size="small" placeholder="请输入电话"
                        clearable></el-input>
                    <el-input v-model="formDatas.idCard" style="width: 140px;" size="small" placeholder="请输入身份证号码"
                        clearable></el-input>
                    <el-input v-model="formDatas.name" style="width: 140px;" size="small" placeholder="请输入姓名"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.hasSignRelation" clearable @change="partserch"
                        placeholder="请选择是否关联" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="yupmId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
        <!-- 关联面试记录弹框 -->
        <el-dialog title="选择面试记录" :visible.sync="associateDialogVisible" width="70%" top="8vh"
            :close-on-press-escape="false" :close-on-click-modal="false" @close="associateDialogClose">
            <div style="margin-bottom: 15px;">
                <el-input v-model="interviewSearchForm.ijaName" style="width: 140px;" size="small" placeholder="应聘者姓名"
                    clearable></el-input>
                <el-input v-model="interviewSearchForm.ijaPhone" style="width: 140px; margin-left: 10px;" size="small" placeholder="手机号码"
                    clearable></el-input>
                <el-button type="info" size="small" icon="el-icon-search" @click="searchInterviewList"
                    style="margin-left: 10px">搜索</el-button>
            </div>
            <ve-table :columns="interviewColumns" :table-data="interviewList" :max-height="400"
                :border-x="true" :border-y="true" :scrollWidth="10" row-key-field-name="iiaId"
                :cell-style-option="cellStyleOption" style="width: 100%" />
            <div v-show="interviewList.length == 0" class="empty-data">暂无面试记录</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="associateDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAssociate">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import { getIvInterviewApplicantList, getIvJobApplicantRecordList, updateIvInterviewApplicantSignUser, addSysColorWare, updateSysColorWare, deleteSysColorWare } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            key: 'yupmId',
            dialog: false,
            edit: false,
            // 关联弹框
            associateDialogVisible: false,
            interviewList: [],
            selectedInterview: null,
            currentRow: null,
            // 面试记录表格列
            interviewColumns: [
                {
                    field: "",
                    key: "radio",
                    title: "选择",
                    width: 60,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h('el-radio', {
                            props: { modelValue: this.selectedInterview && this.selectedInterview.iiaId === row.iiaId },
                            on: { change: () => { this.selectedInterview = row; } }
                        }, '');
                    },
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ijaName",
                    key: "ijaName",
                    title: "应聘者",
                    width: 90,
                    align: "center",
                },
                {
                    field: "ijaPost",
                    key: "ijaPost",
                    title: "应聘岗位",
                    width: 120,
                    align: "center",
                },
                {
                    field: "ijaDateInterview",
                    key: "ijaDateInterview",
                    title: "面试日期",
                    width: 100,
                    align: "center",
                },
                {
                    field: "ijaTimeInterview",
                    key: "ijaTimeInterview",
                    title: "面试时间",
                    width: 80,
                    align: "center",
                },
                {
                    field: "ijcName",
                    key: "ijcName",
                    title: "招聘渠道",
                    width: 100,
                    align: "center",
                },
            ],
            // 面试记录搜索表单
            interviewSearchForm: {
                ijaName: '',
                ijaPhone: '',
            },
            form: {
                afcName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
               
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                // {
                //     field: "ijaId",
                //     key: "ijaId",
                //     title: "应聘者",
                //     align: "center",
                //     edit: false,
                // },
                  {
                    field: "name",
                    key: "name",
                    title: "姓名",
                    align: "center",
                    edit: false,
                },
                {
                    field: "ijaId",
                    key: "ijaId",
                    title: "关联状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.ijaId == null||row.ijaId == ''
                            ? h('span', { style: { color: '#E64340' } }, '未关联')
                            : h('span', { style: { color: '#67C23A' } }, '已关联');
                    },
                },
                {
                    field: "phone",
                    key: "phone",
                    title: "电话",
                    align: "center",
                    edit: false,
                },
                // {
                //     field: "idCard",
                //     key: "idCard",
                //     title: "身份证号码",
                //     align: "center",
                //     edit: false,
                // },
              
                // {
                //     field: "gender",
                //     key: "gender",
                //     title: "性别",
                //     align: "center",
                //     edit: false,
                // },
               
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        // 打开关联弹框
        openAssociateDialog(row) {
            this.currentRow = row;
            this.interviewSearchForm = {
                ijaName: '',
                ijaPhone: '',
            };
            this.selectedInterview = null;
            this.searchInterviewList();
            this.associateDialogVisible = true;
        },
        // 搜索面试记录列表
        searchInterviewList() {
            const params = {
                ...this.interviewSearchForm,
                dmDelete: 1,
                currentPage: 1,
                pageSize: 50,
            };
            getIvJobApplicantRecordList(params).then((res) => {
                this.interviewList = res.data || [];
            });
        },
        // 关联弹框关闭
        associateDialogClose() {
            this.currentRow = null;
            this.interviewList = [];
            this.selectedInterview = null;
        },
        // 确认关联
        confirmAssociate() {
            if (!this.selectedInterview) {
                this.$message({
                    showClose: true,
                    message: "请选择面试记录",
                    type: 'warning'
                });
                return;
            }
            const params = {
                iiaId: this.selectedInterview.iiaId,
                ijaId: this.currentRow.ijaId,
            };
            updateIvInterviewApplicantSignUser(params).then((res) => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "关联成功!",
                    });
                    this.associateDialogVisible = false;
                    this.getList();
                }
            });
        },
        // 取消关联
        cancelAssociate(row) {
            this.$confirm("是否确定取消关联?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const params = {
                        iiaId: '',
                        ijaId: row.ijaId,
                    };
                    updateIvInterviewApplicantSignUser(params).then((res) => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "取消关联成功!",
                            });
                            this.getList();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteSysColorWare({ yupmIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteSysColorWare({ yupmIds: row.yupmId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addSysColorWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateSysColorWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.yupmId = row.yupmId
                    console.log(jsonObj);
                    updateSysColorWare(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvInterviewApplicantList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvInterviewApplicantList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvInterviewApplicantList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>